import React, { Fragment, useState } from "react";
import { Dialog, Tab, Transition } from "@headlessui/react";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { XMarkIcon } from "@heroicons/react/24/solid";
import { useTimeoutFn } from "react-use";
import StaySearchFormMobileNR from "./(stay-search-form)/StaySearchFormMobileNR";

const HeroSearchForm2MobileNR = () => {
  const [showModal, setShowModal] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  useTimeoutFn(() => setShowDialog(true), 1);

  function closeModal() {
    setShowModal(false);
  }

  function openModal() {
    setShowModal(true);
  }

  const renderButtonOpenModal = () => {
    return (
      <button
        onClick={openModal}
        className="relative flex items-center w-full bg-white dark:bg-neutral-800 border border-neutral-200 dark:border-neutral-700 px-5 py-3.5 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-200"
      >
        <div className="flex items-center justify-center w-10 h-10 rounded-full bg-primary-50 dark:bg-primary-900/20">
          <MagnifyingGlassIcon className="w-5 h-5 text-primary-600 dark:text-primary-400" />
        </div>

        <div className="ml-3.5 flex-1 text-left overflow-hidden">
          <span className="block font-semibold text-sm text-neutral-900 dark:text-neutral-100">
            Where to?
          </span>
          <div className="block mt-0.5 text-xs text-neutral-500 dark:text-neutral-400">
            <span className="line-clamp-1">
              Neighborhood • Casa • Depa
            </span>
          </div>
        </div>

        <span className="absolute right-3 top-1/2 transform -translate-y-1/2 w-9 h-9 flex items-center justify-center rounded-full bg-neutral-50 dark:bg-neutral-700 border border-neutral-200 dark:border-neutral-600 transition-colors hover:bg-neutral-100 dark:hover:bg-neutral-600">
          <svg
            viewBox="0 0 16 16"
            aria-hidden="true"
            role="presentation"
            focusable="false"
            className="block w-4 h-4 text-neutral-700 dark:text-neutral-300"
            fill="currentColor"
          >
            <path d="M5 8c1.306 0 2.418.835 2.83 2H14v2H7.829A3.001 3.001 0 1 1 5 8zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm6-8a3 3 0 1 1-2.829 4H2V4h6.17A3.001 3.001 0 0 1 11 2zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"></path>
          </svg>
        </span>
      </button>
    );
  };

  return (
    <div className="HeroSearchForm2MobileNR">
      {renderButtonOpenModal()}
      <Transition appear show={showModal} as={Fragment}>
        <Dialog
          as="div"
          className="HeroSearchForm2MobileNR__Dialog relative z-50"
          onClose={closeModal}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/30 backdrop-blur-sm" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-hidden">
            <div className="flex h-full items-end sm:items-center justify-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-full sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-full sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative w-full h-full sm:h-auto sm:max-h-[85vh] sm:max-w-2xl sm:mx-4 bg-neutral-50 dark:bg-neutral-900 sm:rounded-3xl shadow-2xl overflow-hidden flex flex-col">
                  {showDialog && (
                    <Tab.Group manual>
                      {/* Header with close button */}
                      <div className="relative px-6 pt-6 pb-4 bg-white dark:bg-neutral-800 border-b border-neutral-200 dark:border-neutral-700">
                        <button
                          className="absolute left-4 top-4 sm:left-6 sm:top-6 w-10 h-10 flex items-center justify-center rounded-full bg-neutral-100 dark:bg-neutral-700 hover:bg-neutral-200 dark:hover:bg-neutral-600 transition-colors"
                          onClick={closeModal}
                        >
                          <XMarkIcon className="w-5 h-5 text-neutral-700 dark:text-neutral-300" />
                        </button>

                        <Tab.List className="pt-10 flex w-full justify-center font-semibold text-base text-neutral-500 dark:text-neutral-400 space-x-8">
                          {["Stay"].map((item, index) => (
                            <Tab key={index} as={Fragment}>
                              {({ selected }) => (
                                <button className="relative focus:outline-none focus-visible:ring-0 outline-none pb-3 transition-colors">
                                  <span
                                    className={`${
                                      selected
                                        ? "text-neutral-900 dark:text-white"
                                        : "hover:text-neutral-700 dark:hover:text-neutral-300"
                                    }`}
                                  >
                                    {item}
                                  </span>
                                  {selected && (
                                    <span className="absolute inset-x-0 -bottom-px h-0.5 bg-neutral-900 dark:bg-white rounded-full" />
                                  )}
                                </button>
                              )}
                            </Tab>
                          ))}
                        </Tab.List>
                      </div>

                      {/* Content area */}
                      <div className="flex-1 overflow-hidden bg-neutral-50 dark:bg-neutral-900">
                        <Tab.Panels className="h-full overflow-y-auto overscroll-contain">
                          <Tab.Panel className="h-full">
                            <div className="px-4 sm:px-6 py-6">
                              <StaySearchFormMobileNR onClose={closeModal} />
                            </div>
                          </Tab.Panel>
                        </Tab.Panels>
                      </div>
                    </Tab.Group>
                  )}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
};

export default HeroSearchForm2MobileNR;